export default __webpack_public_path__ + "static/media/page-not-found.18d5e44c.svg";